import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {FONT_PROXIMA_13, FONT_WEIGHT_PROXIMA_REGULAR} from 'styles/FontConstants';
import {GRAY_SEMIDARK, NEAR_BLACK} from 'ui-library/Colors';
import {Header3} from 'ui-library/Headers';
import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

interface ActionCalloutProps {
  icon: BenchlingIconName;
  text: string;
}

function ActionCallout({icon, text}: ActionCalloutProps): JSX.Element {
  return (
    <div className={css(styles.actionCalloutContent)}>
      <div className={css(styles.iconContainer)}>
        <BenchlingIcon icon={icon} />
      </div>
      <span className={css(styles.text)}>{text}</span>
    </div>
  );
}

export function DataCaptureEmptyState(): JSX.Element {
  return (
    <div className={css(styles.container)}>
      <Header3 className={css(styles.welcomeHeading)}>Data Capture Assistant</Header3>
      <span className={css(styles.description)}>
        I can help you capture and structure data from your experiments. Describe what you need help with and
        I'll guide you through the process. Try asking for things like:
      </span>

      <div className={css(styles.actionsContainer)}>
        <ActionCallout icon="table" text="Help me organize experimental data" />
        <ActionCallout icon="flask" text="Extract data from my experiment notes" />
        <ActionCallout icon="chart-line" text="Structure my results for analysis" />
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flexGrow: 1,
    textAlign: 'center',
    gap: '18px',
    maxWidth: '500px',
  },
  welcomeHeading: {
    fontSize: '24px',
    fontWeight: FONT_WEIGHT_PROXIMA_REGULAR,
    color: NEAR_BLACK,
  },

  description: {
    ...FONT_PROXIMA_13,
    color: GRAY_SEMIDARK,
    fontWeight: FONT_WEIGHT_PROXIMA_REGULAR,
  },

  actionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },

  actionCalloutContent: {
    display: 'flex',
    alignItems: 'center',
    padding: '4px',
    width: '100%',
    gap: '16px',
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '24px',
    height: '24px',
    fontSize: '20px',
    color: GRAY_SEMIDARK,
  },
  text: {
    ...FONT_PROXIMA_13,
    fontWeight: FONT_WEIGHT_PROXIMA_REGULAR,
    color: NEAR_BLACK,
  },
});
